import { FC, ReactNode } from 'react'

interface IIconSocialMediaProps {
  title: string;
  link: string
  icon: ReactNode,
}

export const IconSocialMedia: FC<IIconSocialMediaProps> = ({ title, link, icon }) => {
  return (
    <a href={link} title={title} target='_blank' className='border border-white/20 rounded-full w-[35px] h-[35px] flex items-center justify-center text-sm hover:text-accent hover:border-accent transition-all' rel="noreferrer">{icon}</a>
  )
}
